export default "__VITE_ASSET__Ba5zYb_g__"